import type { Feature, Point } from 'geojson'
import L from 'leaflet'
import { manualSite } from '../../assets/leafletIcons'

export const MANUAL_SITE_OPACITY = 0.8

const NO_STRATA_COLOR = '#9e9e9e'

const RANDOM_SITE_CIRCLE_STYLE = [
  'filter: saturate(2.5)',
  'border-radius: 50%',
  'border: 2px solid #000',
  'box-shadow: rgba(0,0,0,.5) 1px 1px 3px',
  'width: 100%',
  'height: 100%',
  'display: inline-block',
  'transform: scale(0.8)',
].join('; ')

export const randomSiteIcon = (color: string | undefined): L.DivIcon =>
  L.divIcon({
    className: 'my-div-icon',
    html: `<span style="background-color: ${color || NO_STRATA_COLOR}; ${RANDOM_SITE_CIRCLE_STYLE};"></span>`,
  })

export interface MonitoringSiteMarkerProperties {
  name: string
  isRandomSite?: boolean
  color?: string
}

export const monitoringSitePointToLayer = (
  feature: Feature<Point, MonitoringSiteMarkerProperties>,
  latlng: L.LatLng,
): L.Marker => {
  const { name, isRandomSite, color } = feature.properties

  const marker = isRandomSite
    ? L.marker(latlng, { icon: randomSiteIcon(color) })
    : L.marker(latlng, { icon: manualSite.leafletIcon, opacity: MANUAL_SITE_OPACITY })

  return marker.bindTooltip(name)
}

// The marker binds its own tooltip in pointToLayer, and the layer's default popup would dump
// the raw feature properties — including the presentation-only isRandomSite and color.
export const noMonitoringSitePopup = () => {}
